import axios from 'axios';

export const URL_MAPPING = {
  local: 'http://localhost:8002',
  dev: 'https://serviamed-entregas-api.sisifo.ai',
  prod: 'https://serviamed-entregas-api.sisifo.ai',
};

const ENV_API_URL = "serviamed-entregas-api.sisifo.ai";
const _isPlaceholder = ENV_API_URL.includes('API_URL');
const _isLocal = ENV_API_URL.includes('localhost') || ENV_API_URL.includes('127.0.0.1');
const full_api_url = _isPlaceholder ? null : _isLocal ? `http://${ENV_API_URL}` : `https://${ENV_API_URL}`;
export const API_URL = full_api_url || URL_MAPPING[process.env.REACT_APP_ENV as keyof typeof URL_MAPPING] || URL_MAPPING.local;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }

    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('Token expirado o inválido. Redirigiendo al login.');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

console.log("API_URL:", API_URL);
